/* KIRIBAN membership: the member card sways slowly by itself and follows the mouse on computers (light and foil
   move with it). Runs only while on screen. Also remembers which email form was sent, so the thank-you message
   after the page reloads matches it. */
(function () {
  "use strict";
  var wrap = document.querySelector("[data-kb-mcard]");
  var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (wrap && !reduce) {
    var fine = matchMedia("(hover: hover) and (pointer: fine)"), live = false, raf = 0, hover = null;
    var cur = { rx: 4, ry: -10, mx: .35, my: .3 };
    function frame(now) {
      raf = 0;
      var t = now / 1000, tg;
      if (hover) tg = { rx: (0.5 - hover.y) * 18, ry: (hover.x - 0.5) * 26, mx: hover.x, my: hover.y };
      else tg = { rx: 4 + Math.sin(t * 0.55) * 5, ry: -10 + Math.sin(t * 0.37) * 14, mx: 0.5 + Math.sin(t * 0.37) * 0.38, my: 0.35 + Math.cos(t * 0.55) * 0.25 };
      for (var k in cur) cur[k] += (tg[k] - cur[k]) * (hover ? 0.12 : 0.05);
      wrap.style.setProperty("--rx", cur.rx.toFixed(2) + "deg");
      wrap.style.setProperty("--ry", cur.ry.toFixed(2) + "deg");
      wrap.style.setProperty("--mx", cur.mx.toFixed(3));
      wrap.style.setProperty("--my", cur.my.toFixed(3));
      if (live) raf = requestAnimationFrame(frame);
    }
    wrap.addEventListener("pointermove", function (e) {
      if (!fine.matches) return;
      var r = wrap.getBoundingClientRect();
      hover = { x: Math.min(1, Math.max(0, (e.clientX - r.left) / r.width)), y: Math.min(1, Math.max(0, (e.clientY - r.top) / r.height)) };
    });
    wrap.addEventListener("pointerleave", function () { hover = null; });
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (en) {
        live = en[0].isIntersecting;
        if (live && !raf) raf = requestAnimationFrame(frame);
      }, { rootMargin: "80px 0px" }).observe(wrap);
    } else { live = true; raf = requestAnimationFrame(frame); }
  }

  /* which form was sent */
  var KEY = "kb-form-sent";
  [["formM", "member"], ["form2", "drops"]].forEach(function (p) {
    var f = document.getElementById(p[0]);
    if (f) f.addEventListener("submit", function () { try { sessionStorage.setItem(KEY, p[1]); } catch (e) {} });
  });
  var posted = document.getElementById("kb-posted"), postedM = document.getElementById("kb-posted-m");
  if (posted || postedM) {
    var src = null; try { src = sessionStorage.getItem(KEY); sessionStorage.removeItem(KEY); } catch (e) {}
    if (src === "member" || (postedM && !posted)) {
      var th = document.getElementById("thanks");
      if (th && !posted) { th.setAttribute("data-on", ""); document.body.style.overflow = "hidden"; }
      var t = document.querySelector("#thanks .tin p");
      if (t) t.textContent = "You're on the list. We'll email you as soon as membership registration opens.";
      var m = document.querySelector("#subscribe .fok");
      if (m) m.hidden = true;
    }
  }
})();
